// import React, { useEffect } from "react";
// import HighlightText from '../components/core/HomePage/HighlightText'
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import About1 from '../assets/about1.jpeg'
// import About2 from '../assets/about2.jpeg'
// import About3 from '../assets/about3.jpeg'

// const About = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//     });
//     AOS.refresh();
//   }, []);
//   return (
//     <div>
//       <section className="bg-richblack-800">
//       <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-center text-white">
//           <header data-aos="zoom-in" className="mx-auto py-20 text-4xl font-semibold lg:w-[70%]">
//             Driving Innovation in Online Education for a
//             <HighlightText text={"Brighter Future"} />
//             <p className="mx-auto mt-3 text-center text-base font-medium text-richblack-300 lg:w-[95%]">
//             Level up your skills with Mavenstech Solutions' trending courses. Explore in-demand tech topics and unlock your career potential. Start learning today! 
//             </p>
//           </header>
//           <div className="sm:h-[70px] lg:h-[150px]"></div>
//           <div className="absolute bottom-0 left-[50%] grid w-[55%] translate-x-[-50%] translate-y-[30%] grid-cols-2 gap-3 lg:gap-5">
//             <img className="rounded-xl" src={About1} alt="" />
//             <img className="rounded-xl" src={About2} alt="" />
//             {/* <img data-aos="flip-right" className="rounded-xl" src={About3} alt="" /> */}
//           </div>
//       </div>
//       </section>
//     </div>
//   )
// }

// export default About

import React, { useEffect } from "react";
import HighlightText from '../components/core/HomePage/HighlightText';
import AOS from 'aos';
import 'aos/dist/aos.css';
import About1 from '../assets/about1.jpeg';
import About2 from '../assets/about2.jpeg';
import About3 from '../assets/about3.jpeg';
import Footer from "../components/common/Footer";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
    AOS.refresh();
  }, []);

  return (
    <div className="bg-richblack-900 text-white">
      {/* Hero Section */}
      <section className="bg-richblack-800">
        <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-center text-white">
          <header data-aos="zoom-in" className="mx-auto py-20 text-4xl font-semibold lg:w-[70%]">
            Driving Innovation in Online Education for a
            <HighlightText text={" Brighter Future"} />
            <p className="mx-auto mt-3 text-center text-base font-medium text-richblack-300 lg:w-[95%]">
              Level up your skills with Mavenstech Solutions' trending courses. Explore in-demand tech topics and unlock your career potential. Start learning today!
            </p>
          </header>
          <div className="sm:h-[70px] lg:h-[150px]"></div>
          <div className="absolute bottom-0 left-[50%] grid w-[55%] translate-x-[-50%] translate-y-[30%] grid-cols-2 gap-3 lg:gap-5">
            <img data-aos="fade-right" className="rounded-xl shadow-md" src={About1} alt="Training session" />
            <img data-aos="fade-left" className="rounded-xl shadow-md" src={About2} alt="Learning environment" />
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="pt-32 pb-16">
        <div className="mx-auto w-11/12 max-w-maxContent">
          {/* Welcome Section */}
          <div data-aos="fade-up" className="mb-16 flex flex-col items-center">
            <h2 className="text-3xl font-bold mb-6">Welcome to <HighlightText text={"Mavens Technology Solutions"} /></h2>
            <div className="w-full max-w-3xl text-center">
              <p className="text-richblack-300 mb-4">
                Your trusted partner in professional development. As a leading provider of Artificial Intelligence, Project Management, and Service Management courses, we are committed to helping professionals across industries develop the skills and expertise needed for recognition and growth in the corporate world.
              </p>
              <p className="text-richblack-300">
                Our courses are designed to empower you with the knowledge required to succeed in today's rapidly evolving technological and business landscapes.
              </p>
            </div>
          </div>

          {/* Courses Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {/* AI Courses */}
            <div 
              data-aos="fade-up" 
              data-aos-delay="100" 
              className="bg-richblack-800 p-6 rounded-xl hover:bg-richblack-700 transition-all duration-300 shadow-lg transform hover:-translate-y-1"
            >
              <h3 className="text-xl font-bold mb-4 text-yellow-50">Artificial Intelligence Courses</h3>
              <p className="text-richblack-300">
                Our AI programs provide both beginners and professionals with a deep understanding of core AI concepts. From machine learning to neural networks and natural language processing, our courses are taught by industry experts, combining theoretical knowledge with practical hands-on experience.
              </p>
            </div>

            {/* Project Management Courses */}
            <div 
              data-aos="fade-up" 
              data-aos-delay="200" 
              className="bg-richblack-800 p-6 rounded-xl hover:bg-richblack-700 transition-all duration-300 shadow-lg transform hover:-translate-y-1"
            >
              <h3 className="text-xl font-bold mb-4 text-yellow-50">Project Management Courses</h3>
              <p className="text-richblack-300">
                Master essential skills required to lead successful projects. Learn methodologies such as Agile, Scrum, and Waterfall, and how to manage teams effectively to deliver projects on time and within budget. Advance your career with our comprehensive project management programs.
              </p>
            </div>

            {/* Service Management Courses */}
            <div 
              data-aos="fade-up" 
              data-aos-delay="300" 
              className="bg-richblack-800 p-6 rounded-xl hover:bg-richblack-700 transition-all duration-300 shadow-lg transform hover:-translate-y-1"
            >
              <h3 className="text-xl font-bold mb-4 text-yellow-50">Service Management Courses</h3>
              <p className="text-richblack-300">
                Gain expertise required to manage and optimize IT services effectively. Our Service Management programs cover globally recognized frameworks such as ITIL and SIAM, ensuring you are prepared to excel in roles focused on service delivery and continuous improvement.
              </p>
            </div>
          </div>

          {/* Certifications */}
          <div data-aos="fade-up" className="mb-16">
            <h2 className="text-2xl font-bold mb-6 text-center">Professional <HighlightText text={"Certifications"} /></h2>
            <div className="bg-richblack-800 p-8 rounded-xl shadow-lg">
              <p className="text-richblack-300 text-center mb-6">
                We offer professional certification programs in globally recognized courses such as PRINCE2, DevOps, PMP, Six Sigma, ITIL, and many more. These certifications help professionals gain the recognition they deserve and open up new avenues for career growth.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                {["PRINCE2", "DevOps", "PMP", "Six Sigma", "ITIL", "Agile", "Scrum Master"].map((cert, index) => (
                  <span 
                    key={index} 
                    className="bg-richblack-700 text-yellow-50 px-4 py-2 rounded-full text-sm font-medium"
                  >
                    {cert}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Expert Trainers */}
          <div data-aos="fade-up" className="mb-16 flex flex-col md:flex-row gap-8 items-center">
            <div className="md:w-1/3">
              <img 
                src={About3} 
                alt="Expert trainers" 
                className="rounded-xl shadow-lg w-full"
              />
            </div>
            <div className="md:w-2/3">
              <h2 className="text-2xl font-bold mb-4"><HighlightText text={"Expert Trainers"} /></h2>
              <p className="text-richblack-300 mb-4">
                Our professional trainers possess extensive experience and have acquired the requisite competence in their respective fields. This allows us to leverage their real-world expertise, ensuring that our training programs are enriched with live experiences and practical insights.
              </p>
              <p className="text-richblack-300">
                Our trainers typically employ the most effective and engaging methods to ensure that professionals can apply what they learn in real-world scenarios. We employ esteemed full-time trainers who are dedicated to fostering successful learning outcomes and creating an environment that supports growth, collaboration, and knowledge transfer.
              </p>
            </div>
          </div>

          {/* Closing Statement */}
          <div data-aos="fade-up" className="text-center">
            <h2 className="text-2xl font-bold mb-4">Join <HighlightText text={"Mavens Technology Solutions"} /> Today</h2>
            <p className="text-richblack-300 max-w-3xl mx-auto mb-8">
              We're one of the leading training providers and are gradually expanding our training facilities to reach candidates across different geographies. With our established track record of success and industry partnerships, we are dedicated to providing the tools and resources necessary for your professional advancement.
            </p>
            <button className="bg-yellow-50 text-richblack-900 font-medium px-6 py-3 rounded-md hover:bg-yellow-100 transition-all duration-300">
              Explore Our Courses
            </button>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default About;